window.rebuyHooks = window.rebuyHooks || {};
window.rebuyHooks.crossSellAdd = function () {
  const cartElement = document.querySelector('.rebuy-cart__flyout');
  const notificationElement = document.createElement('div');
  
  notificationElement.classList.add('flyout-notification')
  notificationElement.setAttribute('hidden', '');
  notificationElement.insertAdjacentHTML('afterbegin', `
      <div class="flyout-notification__icon-wrap">
          <svg class="flyout-notification__icon" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 2.62121L2.97059 5.16667L7.5 0.5" stroke="black"/></svg>
      </div>
      <p class="flyout-notification__text">Zum Warenkorb hinzugefügt!</p>
  `);
  
  cartElement.append(notificationElement);

  setTimeout(() => {
      notificationElement.classList.add('flyout-notification--show');
  }, 0);
  
  setTimeout(() => {
      notificationElement.classList.remove('flyout-notification--show');
  
      setTimeout(() => {
          notificationElement.remove();
      }, 500);
  }, 2000);
};

function toggleCartEmptyState(cart) {
  setTimeout(() => {
    if (cart.hasItems()) {
      cart.view.$el.classList.remove('no-items');
    } else {
      cart.view.$el.classList.add('no-items');
      cart.view.$el.querySelector('.rebuy-cart__flyout-empty-cart').innerHTML = `
        <p class="rebuy-cart__empty-title">Dein Warenkorb ist leer</p>
        <p class="rebuy-cart__empty-description">Dass lässt sich ändern 👇</p>
        <a class="rebuy-cart__empty-button" href="/collections/alle-zimmerpflanzen">PFLANZEN ENTDECKEN</p>
      `;
    }
  }, 0);
}

window.rebuyHooks.crossSellReady = function (widget) {
  setTimeout(() => {
    widget.View.carousel.options.wrapAround = false;
    widget.View.carousel.options.freeScroll = true;
    widget.View.carousel.options.contain = true;
    widget.View.carousel.resize();
  }, 0);
};

window.rebuyHooks.cartShow = toggleCartEmptyState;
window.rebuyHooks.itemIncrease = toggleCartEmptyState;
window.rebuyHooks.itemDecrease = toggleCartEmptyState;
window.rebuyHooks.itemRemoved = toggleCartEmptyState;